// Services data for Renewed Environmental

export const services = [
  {
    id: "bin-rentals",
    slug: "bin-rentals",
    title: "Bin Rentals",
    shortDescription: "Flexible dumpster rentals for any project size",
    heroImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200",
    icon: "Container",
    headline: "Dumpster Rentals Made Simple",
    description: "From small home cleanouts to large construction projects, our bin rental service provides the flexibility and reliability you need. We offer a wide range of sizes with transparent pricing and on-time delivery guaranteed.",
    highlights: [
      "Same-day or next-day delivery available",
      "Flexible rental periods (7+ days standard)",
      "Transparent, all-inclusive pricing",
      "Multiple bin sizes from 4 to 40 yards"
    ],
    startingPrice: 240
  },
  {
    id: "waste-management",
    slug: "waste-management",
    title: "Waste Management",
    shortDescription: "Complete waste solutions for businesses and municipalities",
    heroImage: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=1200",
    icon: "Recycle",
    headline: "Comprehensive Waste Solutions",
    description: "Our integrated waste management services help businesses, municipalities, and institutions reduce costs, improve efficiency, and meet environmental compliance requirements.",
    highlights: [
      "Customized collection schedules",
      "Waste audits and reduction consulting",
      "Regulatory compliance support",
      "Detailed reporting and analytics"
    ],
    startingPrice: null
  },
  {
    id: "remediation",
    slug: "remediation",
    title: "Remediation",
    shortDescription: "Environmental cleanup and site restoration services",
    heroImage: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200",
    icon: "ShieldCheck",
    headline: "Environmental Remediation Experts",
    description: "When contamination threatens your property or project, our remediation team delivers proven solutions. From soil and groundwater cleanup to tank removals and site restoration.",
    highlights: [
      "Licensed and certified technicians",
      "Full regulatory compliance",
      "Risk assessment and management",
      "Post-remediation monitoring"
    ],
    startingPrice: null
  },
  {
    id: "soil-management",
    slug: "soil-management",
    title: "Soil Management",
    shortDescription: "Expert handling of excess and contaminated soils",
    heroImage: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1200",
    icon: "Mountain",
    headline: "Professional Soil Management",
    description: "Managing excess soil from construction and development projects requires expertise in regulations, testing, and disposal options. We provide end-to-end soil management services.",
    highlights: [
      "Soil characterization and testing",
      "Excess soil registry compliance",
      "Clean fill sourcing and placement",
      "Contaminated soil disposal"
    ],
    startingPrice: null
  },
  {
    id: "underground-hydrovac",
    slug: "underground-hydrovac",
    title: "Underground & Hydrovac",
    shortDescription: "Safe excavation for utilities and infrastructure",
    heroImage: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200",
    icon: "Droplets",
    headline: "Precision Hydrovac Excavation",
    description: "When you need to excavate near buried utilities, hydrovac is the safest and most efficient choice. Our high-powered vacuum trucks use pressurized water to break up soil safely.",
    highlights: [
      "Non-destructive excavation",
      "Utility locate verification",
      "Winter excavation capable",
      "Minimal site disruption"
    ],
    startingPrice: null
  },
  {
    id: "scrap-metal-recycling",
    slug: "scrap-metal-recycling",
    title: "Scrap Metal Recycling",
    shortDescription: "Turn your scrap metal into value",
    heroImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200",
    icon: "Factory",
    headline: "Scrap Metal Recycling Services",
    description: "Don't let valuable scrap metal go to waste. Our recycling program accepts ferrous and non-ferrous metals from construction, demolition, and manufacturing projects.",
    highlights: [
      "Competitive market pricing",
      "Pickup service available",
      "All metals accepted",
      "Certified weight tickets"
    ],
    startingPrice: null
  }
];

// Service page content
export const serviceContent = {
  "bin-rentals": {
    features: [
      { title: "Residential Bins", description: "Perfect for home renovations, garage cleanouts, and yard waste. Our residential bins fit easily in driveways.", details: ["12-20 yard options", "Driveway-friendly dimensions", "7-day rental included"] },
      { title: "Construction Bins", description: "Heavy-duty roll-off containers designed for construction sites, demolition debris, and commercial projects.", details: ["14-40 yard capacity", "Handles heavy materials", "Scheduled exchanges available"] },
      { title: "Clean Fill Bins", description: "Specialized bins for dirt, concrete, asphalt, brick, and other inert materials at reduced rates.", details: ["Flat-rate pricing", "Recycling focused", "4-14 yard sizes"] }
    ],
    process: [
      { step: 1, title: "Choose Your Size", description: "Tell us about your project and we'll recommend the right bin size." },
      { step: 2, title: "Schedule Delivery", description: "Pick a date and time that works for you." },
      { step: 3, title: "Fill It Up", description: "Take your time loading the bin. Stay within the fill line." },
      { step: 4, title: "We Haul It Away", description: "Call us when you're done and we'll pick it up promptly." }
    ],
    faqs: [
      { q: "How long can I keep the bin?", a: "Standard rental is 7 days. Extensions available at daily rates." },
      { q: "What can't go in the bin?", a: "Hazardous materials, tires, batteries, paint, and propane tanks are prohibited." },
      { q: "Do I need a permit?", a: "If placed on public property, yes. We can guide you through the process." }
    ]
  },
  "waste-management": {
    features: [
      { title: "Commercial Collection", description: "Scheduled waste and recycling pickup for businesses of all sizes.", details: ["Flexible scheduling", "Front-load and roll-off options", "Multi-stream recycling"] },
      { title: "Industrial Waste Services", description: "Specialized handling for manufacturing and industrial facilities.", details: ["Hazardous waste coordination", "Bulk material handling", "Compliance documentation"] },
      { title: "Municipal Partnerships", description: "Collaborative programs with local governments for residential collection.", details: ["Curbside collection", "Special event services", "Public education support"] }
    ],
    process: [
      { step: 1, title: "Waste Assessment", description: "We analyze your current waste streams and identify opportunities." },
      { step: 2, title: "Custom Solution Design", description: "Our team develops a tailored plan to meet your goals." },
      { step: 3, title: "Implementation", description: "We deploy equipment, train staff, and begin service." },
      { step: 4, title: "Ongoing Optimization", description: "Regular reviews ensure continuous improvement." }
    ],
    faqs: [
      { q: "Do you provide recycling services?", a: "Yes, we offer comprehensive single-stream and source-separated recycling." },
      { q: "Can you help with waste reduction?", a: "Our consultants can perform waste audits and recommend reduction strategies." },
      { q: "What industries do you serve?", a: "We serve retail, hospitality, healthcare, manufacturing, construction, and more." }
    ]
  },
  "remediation": {
    features: [
      { title: "Soil Remediation", description: "Removal, treatment, and disposal of contaminated soils.", details: ["Petroleum contamination", "Heavy metals", "Industrial chemicals"] },
      { title: "Groundwater Treatment", description: "Assessment and remediation of groundwater contamination.", details: ["Monitoring well installation", "Plume delineation", "Long-term monitoring"] },
      { title: "Tank Removal", description: "Safe removal of underground and aboveground storage tanks.", details: ["UST/AST removal", "Soil sampling", "Regulatory closure"] }
    ],
    process: [
      { step: 1, title: "Site Assessment", description: "Environmental investigation to characterize contamination." },
      { step: 2, title: "Remediation Planning", description: "Develop a cost-effective strategy that meets requirements." },
      { step: 3, title: "Active Remediation", description: "Execute cleanup using appropriate technologies." },
      { step: 4, title: "Site Closure", description: "Document completion and obtain regulatory sign-off." }
    ],
    faqs: [
      { q: "What contaminants do you handle?", a: "We address petroleum products, solvents, heavy metals, and industrial chemicals." },
      { q: "Do you work with regulators?", a: "Yes, we manage all regulatory communications and reporting." },
      { q: "How long does remediation take?", a: "Timeline varies from weeks to years depending on severity." }
    ]
  },
  "soil-management": {
    features: [
      { title: "Excess Soil Handling", description: "Comprehensive management of excess soil from excavation projects.", details: ["O. Reg. 406/19 compliance", "Beneficial reuse options", "Documentation management"] },
      { title: "Soil Testing", description: "Laboratory analysis to determine soil quality and disposal pathways.", details: ["Table 1-3 testing", "Quick turnaround", "Certified laboratories"] },
      { title: "Clean Fill Supply", description: "Source and deliver certified clean fill for your construction needs.", details: ["Quality verified", "Competitive pricing", "Bulk delivery"] }
    ],
    process: [
      { step: 1, title: "Project Review", description: "Understand your excavation plans and soil management needs." },
      { step: 2, title: "Sampling & Testing", description: "Collect and analyze soil samples to determine quality." },
      { step: 3, title: "Logistics Planning", description: "Arrange transport and identify receiving sites." },
      { step: 4, title: "Execution", description: "Move soil efficiently while maintaining documentation." }
    ],
    faqs: [
      { q: "What is the excess soil regulation?", a: "Ontario Reg. 406/19 governs how excess soil must be managed and tracked." },
      { q: "Do you handle contaminated soil?", a: "Yes, we work with licensed facilities for proper treatment." },
      { q: "Can you help with soil registry?", a: "We manage all registry requirements and documentation." }
    ]
  },
  "underground-hydrovac": {
    features: [
      { title: "Utility Daylighting", description: "Safely expose buried utilities for inspection or repair.", details: ["Gas, electric, telecom, water", "Precise exposure", "Photo documentation"] },
      { title: "Potholing & Trenching", description: "Create test holes or narrow trenches to locate utilities.", details: ["Small footprint", "Fast execution", "Reduced restoration"] },
      { title: "Debris Removal", description: "Remove soil, mud, and materials from excavations and confined spaces.", details: ["Industrial cleaning", "Emergency response", "Spill cleanup"] }
    ],
    process: [
      { step: 1, title: "Site Review", description: "Review locate information and plan excavation approach." },
      { step: 2, title: "Setup & Safety", description: "Position equipment and establish work zone safety." },
      { step: 3, title: "Hydrovac Excavation", description: "Precision excavation using water and vacuum technology." },
      { step: 4, title: "Backfill & Cleanup", description: "Restore site or leave exposed for your work." }
    ],
    faqs: [
      { q: "What is hydrovac excavation?", a: "It uses pressurized water to loosen soil and vacuum to remove it safely." },
      { q: "Can you work in winter?", a: "Yes, we use heated water to excavate frozen ground." },
      { q: "How deep can you excavate?", a: "Our equipment can reach depths of 60+ feet." }
    ]
  },
  "scrap-metal-recycling": {
    features: [
      { title: "Ferrous Metals", description: "Recycling of steel, iron, and other magnetic metals.", details: ["Structural steel", "Rebar and mesh", "Equipment and machinery"] },
      { title: "Non-Ferrous Metals", description: "Higher-value recycling of copper, aluminum, brass, and stainless.", details: ["Copper wire and pipe", "Aluminum siding", "Stainless fixtures"] },
      { title: "E-Waste & Appliances", description: "Responsible recycling of electronics and appliances.", details: ["Computers and electronics", "HVAC equipment", "Appliances"] }
    ],
    process: [
      { step: 1, title: "Material Assessment", description: "Identify and sort your scrap materials for best value." },
      { step: 2, title: "Pickup or Drop-off", description: "We'll collect large quantities or accept drop-offs." },
      { step: 3, title: "Weighing & Grading", description: "Certified scales and expert grading ensure fair pricing." },
      { step: 4, title: "Payment", description: "Receive payment promptly based on current market rates." }
    ],
    faqs: [
      { q: "What metals do you accept?", a: "We accept virtually all ferrous and non-ferrous metals." },
      { q: "Do you offer pickup?", a: "Yes, we provide pickup service for larger quantities." },
      { q: "How is pricing determined?", a: "Prices are based on current commodity markets and metal type." }
    ]
  }
};
